import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'ai-assist',
    loadComponent: () => import('@chatbot').then((m) => m.AiAssistComponent),
  },
  {
    path: '',
    redirectTo: 'ai-assist',
    pathMatch: 'full',
  },
];
